<template>
    <v-container class="d-flex">
                <v-card class="mt-40 v-card-width" elevation="0">
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Account Number
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ this.virtualAccountNumber }}
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            IFSC
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ this.ifsc }}
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Account Type
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            Current
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Account Holder Name
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ userName }}
                        </v-col>
                    </v-row>
                </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'Settings',
    data () {
        return {
            accountInfo: null,
            virtualAccountNumber: '',
            ifsc: '',
            userName: ''
        }
    },
    filters: {
        formatName (string) {
            const names = string.split(' ')
            const initials = names[0].substring(0, 1).toUpperCase()
            return initials
        }
    },
    mounted () {
        this.accountInfo = this.$store.getters['dashboard/getAccountInfo']
        this.virtualAccountNumber = this.accountInfo?.virtualAccountNumber
        this.ifsc = this.accountInfo?.ifsc
        this.userName = this.$store.state.userName || this.$store.state.onBoarding.Name
    },
    methods: {
        goBack () {
            this.$router.push('/dashboard')
        },
        refreshPage () {
            this.$router.go()
        },
        editProfileImage () {
            this.showEditProfileDialog = true
        },
        closeEditProfileDialog () {
            this.showEditProfileDialog = false
        },
        editPhoneNo () {
            this.showEditPhoneDialog = true
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/_dashboard-layout.scss";

.v-card-width {
    flex: 1
}

hr {
    height: 0px;
    border: 0.5px solid rgba(189, 189, 189, 0.3);
    opacity: 0.5;
}

.heading {
    font-weight: 500;
    font-size: 18px;
    color: #4f4f4f;
}
.text {
    position: relative;
    color: #4f4f4f;
    justify-content: flex-end;
}
.short-text{
    display: none;
}

@media (max-width: 600px) {
    #settings {
        justify-content: flex-start;
    }
    .short-text{display: inline-block;}
    .container{
        justify-content: start !important;
    }
    .mt-60.v-card.v-sheet.theme--light.elevation-0{
        margin-top:10px !important;
    }
    .row{
        flex-direction: column;
        padding: 10px !important;
    }
    .v-card-width {
        width: 100% !important;
    }
}

    .textContainer {
        align-items: center
    }

</style>
